/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CreateOnboardingServiceApiArg, OnboardingDraftService } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createOnboardingService: build.mutation<OnboardingDraftService, CreateOnboardingServiceApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/onboarding/service`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as createOnboardingServiceApi };
export const { useCreateOnboardingServiceMutation } = injectedRtkApi;
